import { render, staticRenderFns } from "./PurchasedCoins.vue?vue&type=template&id=117ff927&scoped=true&"
import script from "./PurchasedCoins.vue?vue&type=script&lang=ts&"
export * from "./PurchasedCoins.vue?vue&type=script&lang=ts&"
import style0 from "./PurchasedCoins.vue?vue&type=style&index=0&id=117ff927&lang=sass&scoped=true&"
import style1 from "./PurchasedCoins.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117ff927",
  null
  
)

export default component.exports